<template>
  <a-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading" switchFullscreen
    @ok="handleOk" @cancel="handleCancel" cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{ labelCol: { span: 4 }, wrapperCol: { span: 14 }, }"
        ref="ruleForm" :rules="rules">
        <a-form-model-item prop="name" label="表单名称">
          <a-input placeholder="请输入表单名称" v-model="model.name" />
        </a-form-model-item>
        <a-form-model-item prop="nameEn" label="英文名称">
          <a-input placeholder="请输入英文名称" v-model="model.nameEn" />
        </a-form-model-item>

        <a-form-model-item prop="type" label="表单类型">
          <a-select placeholder="请选择" v-model="model.type">
            <a-select-option value="1">表单</a-select-option>
            <a-select-option value="2">量表</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="description" label="表单说明">
          <a-textarea :rows="2" placeholder="请输入表单说明" v-model="model.description" />
        </a-form-model-item>
        <a-form-model-item prop="inputTip" label="填写提示">
          <a-textarea :rows="2" placeholder="请输入填写提示" v-model="model.inputTip" />
        </a-form-model-item>
        <a-form-model-item prop="testType" label="测评方式">
          <a-select v-model='model.testType' placeholder='请选择'>
            <a-select-option value="0">自评</a-select-option>
            <a-select-option value="1">他评</a-select-option>
            <a-select-option value="2">均可</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item prop="unnecessary" label="是否选填" help="选择否代表该表单必填">
          <a-switch checkedChildren="是" unCheckedChildren="否" v-model="unnecessary" @change="onSwitchChange" />
        </a-form-model-item>
        <!-- <a-space> -->
        <a-form-model-item v-show="model.unnecessary === 1" prop="optionCenterIds" label="选填中心"
          help="选择的中心需要填写当前表单，未选择的中心将不填此表单">
          <a-select v-model="model.centerIdList" mode="multiple" @change="centerChange">
            <a-select-option :value="item.id" v-for="item in centerList">{{ item.name }}</a-select-option>
          </a-select>
          <!-- <template #help>请确保您输入的邮箱地址是正确的，以便接收我们的邮件通知。</template> -->
        </a-form-model-item>
        <!-- </a-space> -->
        <a-form-model-item v-show="model.unnecessary === 1" prop="applyAllPatient" label="受试者表单选填"
          help="勾选后将按上述选填规则，生效已收集的受试者表单填写规则">
          <a-checkbox v-model="model.applyAllPatient">
          </a-checkbox>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import baseRules from '@/constants/baseRules'

export default {
  name: "ProjectFormModal",
  components: { ATextarea },
  props: {
    projectId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      title: "操作",
      visible: false,
      model: {
        name
      },
      rules: {
        name: [baseRules.required],
        type: [baseRules.required],
      },
      confirmLoading: false,

      url: {
        add: "/project/projectForm/add",
        edit: "/project/projectForm/edit",
      },
      unnecessary: false,
      centerList: [],
    }
  },
  created() {
  },
  methods: {
    add() {
      this.edit({
        projectId: this.projectId,

      });
    },
    edit(record) {
      this.model = Object.assign({}, record);
      this.visible = true;
      this.unnecessary = this.model.unnecessary === 1 ? true : false;
      this.initcenter()

      let centerIdList = []
      if (record.optionCenterIds) {
        centerIdList = record.optionCenterIds.split(',')
      }
      this.model = Object.assign({ centerIdList: centerIdList }, this.model);
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
          }
          let formData = this.model;

          httpAction(httpurl, formData, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
            that.close();
          })
        } else {
          return false;
        }
      })
    },
    handleCancel() {
      this.close()
    },
    onSwitchChange(checked) {
      this.model.unnecessary = checked ? 1 : 0
    },
    checkedChange(key, record, e) {
      if (e.target.checked) {
        record[key] = '1'
      } else {
        record[key] = '0'
      }
    },
    centerChange(keys) {
      let ids = ''
      keys.forEach(item => {
        ids += item + ','
      })
      if (ids.length > 0) {
        ids = ids.substring(0, ids.length - 1)
      }
      this.$set(this.model, 'optionCenterIds', ids)
    },
    initcenter() {
      getAction('/management/center/listAll', { status: '1' }).then(res => {
        if (res.success) {
          this.centerList = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped></style>